export const APP_TAB = {
  CARD_COLLECTION: "card-collection",
  PATIENT_AR: "patient-ar",
} as const;

export type AppTab = (typeof APP_TAB)[keyof typeof APP_TAB];

export const APP_TAB_PATH: Record<AppTab, string> = {
  [APP_TAB.CARD_COLLECTION]: "",
  [APP_TAB.PATIENT_AR]: "/patient-ar",
};
